import React, { useState, useEffect } from "react";
import InfoIcon from "../icons/InfoIcon";
import Tooltip from "./Tooltip";
import { useTranslationContext } from "../context/TranslationsProvider"; 

const SeguroCheckbox = ({ seguro, setSeguro }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const { translations } = useTranslationContext();
  const t = (key, fallback) => translations[key] || fallback;

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.matchMedia("(max-width: 768px)").matches);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const tooltipContent = (
    <>
      <p>
        {t('bdo-libranza-tooltip-insurance', 'Seguro ofrecido por Seguros Alfa S.A que cubre las cuotas del crédito temporalmente en caso de perder el empleo sin justa causa si es empleado o pensionado, o si queda incapacitado como empleado del sector oficial. En ambos casos cubre el diagnóstico de enfermedades graves y de cáncer femenino o masculino.')}
      </p>
    </>
  );

  const handleInfoClick = (e) => {
    if (isMobile) {
      e.preventDefault();
      e.stopPropagation();
      setShowTooltip(!showTooltip);
    }
  };

  const handleMouseEnter = () => {
    if (!isMobile) {
      setShowTooltip(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setShowTooltip(false);
    }
  };

  return (
    <div className="seguro-checkbox-container">
      <label className="seguro-checkbox">
        <input
          type="checkbox"
          checked={seguro}
          onChange={() => setSeguro(!seguro)}
          className="seguro-checkbox-input"
        />
        <span className="form-label">
          {t('bdo-libranza-checkbox-include-insurance', 'Incluir seguro de cuota protegida')}
        </span>
        <div 
          className="tooltip-wrapper"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <button
            type="button"
            className="info-icon-wrapper"
            onClick={handleInfoClick}
          >
            <InfoIcon />
          </button>
          <Tooltip isVisible={showTooltip} content={tooltipContent} />
        </div>
      </label>
    </div>
  );
};

export default SeguroCheckbox;
